// extracted by mini-css-extract-plugin
export default {"kg_map":"styles_kg_map__NIbmx","map_title_icon":"styles_map_title_icon__8J6C8","map_title_icon_dot":"styles_map_title_icon_dot__boh3L","kg_map_root":"styles_kg_map_root__8qFub"};